export const GET_LIST = 'app/dealerships/GET_LIST';
export const CREATE_ONE = 'app/dealerships/CREATE_ONE';
export const GET_ONE = 'app/dealerships/GET_ONE';
export const EDIT_ONE = 'app/dealerships/EDIT_ONE';
export const UPLOAD_CSV = 'app/dealerships/UPLOAD_CSV';
